import styled from "styled-components";

import { Metrics } from "../../vars";

export const HeaderbarBottom = styled.div`
  padding-left: ${Metrics.Padding.NAVBAR_LEFT_MD}px;
  border-bottom: 1px solid ${p => p.theme.colors.grey200};

  @media (min-width: ${p => p.theme.breakpoints.xl}) {
    padding-left: ${Metrics.Padding.NAVBAR_LEFT_LG}px;
  }
`;
